import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => {
    // A non-JSON 200 (e.g. an HTML page served while the server restarts) must not reach the UI as data.
    const ct = String(r.headers?.["content-type"] || "");
    if (r.config?.responseType !== "blob" && typeof r.data === "string" && !ct.includes("json") && r.data.trim().startsWith("<")) {
      const err = new Error("Resposta inválida do servidor");
      err.response = { status: 503, data: { detail: "Servidor indisponível no momento. Tente novamente." } };
      return Promise.reject(err);
    }
    return r;
  },
  (err) => {
    if (err.response?.status === 402) {
      window.dispatchEvent(new CustomEvent("subscription-blocked"));
    }
    return Promise.reject(err);
  }
);

const FRIENDLY = {
  subscription_required: "Seu acesso está bloqueado. Assine um plano para continuar.",
  feature_reports: "Relatórios estão disponíveis a partir do plano Profissional.",
  feature_media: "Mídia na TV está disponível a partir do plano Essencial.",
  feature_video: "Vídeos, YouTube e TV ao vivo na TV estão disponíveis a partir do plano Profissional.",
  feature_bulk_import: "Importar/cadastrar listas em massa está disponível a partir do plano Profissional.",
  limit_rooms: "Você atingiu o limite de salas do seu plano. Faça upgrade para adicionar mais.",
  limit_team: "Você atingiu o limite de usuários do seu plano. Faça upgrade para adicionar mais.",
  partner_invalid: "Código de parceiro inválido.",
  no_customer: "Nenhuma assinatura ativa encontrada para abrir o portal.",
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return FRIENDLY[detail] || detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
